/**
 * Chip del estado de una campaña del oficial. Sus estados son otros que los de Activa (`borrador`,
 * `pausada_auto`…): por eso no se reusa `ChipEstado` de campana-nueva, se copia el patrón.
 */

import type { EstadoCampanaOficial } from "../types";
import { ESTADO_CAMPANA } from "../logic/textos";

export function ChipEstadoCampanaOficial({ estado, className = "" }: { estado: EstadoCampanaOficial; className?: string }) {
  const info = ESTADO_CAMPANA[estado] ?? { label: String(estado || "sin estado"), cls: "bg-slate-100 text-slate-500" };
  return (
    <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full whitespace-nowrap ${info.cls} ${className}`}>
      {info.label}
    </span>
  );
}

export default ChipEstadoCampanaOficial;
